import React from "react";
import { FaTrash } from "react-icons/fa";

const ConfirmModal = ({ isOpen, onConfirm, onCancel, clientName }) => {
  if (!isOpen) return null;

  return (
    <div
      onClick={onCancel}
      style={{
        position: "fixed", inset: 0, zIndex: 50,
        display: "flex", alignItems: "center", justifyContent: "center",
        padding: 16,
        background: "rgba(17,24,39,0.45)",
        backdropFilter: "blur(3px)",
        WebkitBackdropFilter: "blur(3px)",
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: "#fff",
          borderRadius: 16,
          border: "1px solid #e5e7eb",
          boxShadow: "0 20px 60px rgba(0,0,0,0.15)",
          padding: "28px 24px",
          width: "100%",
          maxWidth: 360,
        }}
      >
        {/* Icon */}
        <div style={{
          width: 48, height: 48, borderRadius: "50%",
          background: "#fff1f2",
          border: "1px solid #fecdd3",
          display: "flex", alignItems: "center", justifyContent: "center",
          margin: "0 auto 16px",
        }}>
          <FaTrash style={{ color: "#dc2626", fontSize: 18 }} />
        </div>

        {/* Title */}
        <h3 style={{ fontSize: 16, fontWeight: 500, color: "#111827", margin: "0 0 8px", textAlign: "center" }}>
          Elimina ordine
        </h3>

        {/* Message */}
        <p style={{ fontSize: 13, color: "#6b7280", lineHeight: 1.6, margin: "0 0 20px", textAlign: "center" }}>
          Sei sicuro di voler eliminare l'ordine per{" "}
          <strong style={{ color: "#111827" }}>{clientName}</strong>?
          <br />
          <span style={{ color: "#dc2626", fontWeight: 500 }}>Questa azione è irreversibile.</span>
        </p>

        {/* Buttons */}
        <div style={{ display: "flex", gap: 10 }}>
          <button
            onClick={onCancel}
            style={{
              flex: 1, padding: "10px", borderRadius: 8,
              border: "1px solid #e5e7eb", background: "#f9fafb",
              color: "#374151", fontSize: 14, fontWeight: 500,
              cursor: "pointer", fontFamily: "inherit",
            }}
          >
            Annulla
          </button>
          <button
            onClick={onConfirm}
            style={{
              flex: 1, padding: "10px", borderRadius: 8,
              border: "none",
              background: "linear-gradient(135deg, #dc2626, #ef4444)",
              color: "#fff", fontSize: 14, fontWeight: 500,
              cursor: "pointer", fontFamily: "inherit",
            }}
          >
            Elimina
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;